var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-3 -1 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m4.571 8.946.325.186c.63.36 1.36.568 2.104.568.651 0 1.38-.208 2.153-.594l.312-.156.341.071C12.178 9.521 14 11.53 14 13.8V17H0v-3.2c0-2.307 1.765-4.293 4.204-4.78l.367-.074ZM9.7 11.058l-.269.118c-.82.337-1.632.524-2.431.524a6.226 6.226 0 0 1-2.58-.567l-.148-.072-.05.014c-1.27.394-2.14 1.418-2.217 2.56L2 13.8V15h10v-1.2c0-1.17-.94-2.303-2.242-2.725l-.058-.017ZM7 0c2.152 0 4 1.848 4 4 0 2.182-1.777 4-4 4-2.182 0-4-1.777-4-4s1.818-4 4-4Zm0 2c-1.088 0-2 .892-2 2s.912 2 2 2c1.108 0 2-.912 2-2 0-1.048-.952-2-2-2Z"
  })));
};
export default SvgUser;